<template>
  <AppHeaderDropdown no-caret>
    <template slot="header">
      {{ username }} 
      <img
        src="img/avatars/avatar.png"
        class="img-avatar"
        :alt="$store.state.user.username"
      > 
    </template>
    <template slot="dropdown">
      <b-dropdown-item :to="{ name: 'UserSettings' }">
        <i class="fa fa-cog" /> Instellingen
      </b-dropdown-item>
      <b-dropdown-divider />
      <b-dropdown-item @click="logout()">
        <i class="fa fa-lock" /> Logout
      </b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import { serviceMixin } from '@/mixins/serviceMixin';
export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  mixins: [serviceMixin],
  data: () => {
    return {
      profiel : null
    }
  },
  computed: {
    username() {
      return this.$store.state.user.username;
    },
    userInitials() {
      if (this.$store.state.user && this.$store.state.user.username) {
        return this.$store.state.user.username
          .split(" ")
          .map(n => n[0])
          .join("");
      }
      return "";
    },
    userInitialsFromProfile() {
      if (this.profiel && this.profiel.auth && this.profiel.auth.user && this.profiel.auth.user.Naam) {
        return this.profiel.auth.user.Naam
          .split(" ")
          .map(n => n[0])
          .join("");
      }
      return "";
    }
  },
  mounted() {
    this.getProfile()
  },
  methods: {
    logout() {
      this.post('/logout')
        .finally(() => {
          this.$store.dispatch('relaties/disconnectSse');
          this.$store.commit("setUserObject", null);
          this.$router.replace({ name: "Login" });
        });
    },
    getProfile() {
      var vm = this;
      this.get("/user/profile")
        .then(function(response) {
          vm.profiel = response.data;
        })
        .catch(function(error) {
          vm.profiel = error;
        });
    }
  }
}
</script>
